import * as React from 'react';
import { ExpandMore } from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import StylePropertyField from './StylePropertyField';

export default function CustomStyleManager({
  sectors,
}) {
  return (
    <div className="gjs-custom-style-manager text-left space-y-2">
      {sectors.map((sector) => (
        <Accordion 
          key={sector.getId()} 
          disableGutters
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '&:before': {
              display: 'none',
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore className="text-gray-400 w-5 h-5" />}
            className="rounded-xl hover:bg-black-400 transition-colors duration-150"
            sx={{
              minHeight: '48px',
              '&.Mui-expanded': {
                minHeight: '48px',
              }
            }}
          >
            <span className="text-sm font-medium text-gray-700">
              {sector.getName()}
            </span>
          </AccordionSummary>
          <AccordionDetails className="px-2 py-3">
            <div className="bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-gray-100/50 shadow-sm">
              <div className="grid grid-cols-2 gap-4">
                {sector.getProperties().map((prop) => (
                  <StylePropertyField 
                    key={prop.getId()} 
                    prop={prop}
                  />
                ))}
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
